// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__title .text__inner[data-v-4a4f2161]{margin:0;font-size:32px;font-weight:400;line-height:1.13;letter-spacing:normal}.text__title .text__inner.bold[data-v-4a4f2161]{font-weight:700}@media (max-width:575.98px){.text__inner.adaptive[data-v-4a4f2161]{font-size:24px;line-height:1.29}}", ""]);
// Exports
module.exports = exports;
